// extracted by mini-css-extract-plugin
export default {"radioBox":"style_radioBox__Y-2Zs","iconBox":"style_iconBox__16vQZ"};